import PageShell from '../../components/feature/PageShell';
import PageHero from '../../components/feature/PageHero';

const branches = [
  {
    id: 1,
    name: 'MF Dental — San Juan de Aragón',
    badge: 'Sede Principal',
    address: 'Av. 504 #51, Pueblo San Juan de Aragón',
    colony: 'Gustavo A. Madero, CDMX',
    zip: 'C.P. 07950',
    phone: '55 3474 8982',
    whatsapp: 'https://wa.me/525534748982',
    hours: [
      { day: 'Lunes – Viernes', time: '10:00 a.m. – 8:00 p.m.' },
      { day: 'Sábado', time: '10:00 a.m. – 3:00 p.m.' },
      { day: 'Domingo', time: 'Cerrado' },
    ],
    mapSrc:
      'https://maps.google.com/maps?q=Av.+504+51,+Pueblo+San+Juan+de+Aragón,+Gustavo+A.+Madero,+CDMX&output=embed',
    mapLink:
      'https://maps.google.com?q=Av.+504+51,+Pueblo+San+Juan+de+Aragón,+Gustavo+A.+Madero,+CDMX',
    transport: [
      { icon: 'ri-bus-line', label: 'Metro San Juan de Aragón (Línea 5) — 10 min caminando' },
      { icon: 'ri-car-line', label: 'Estacionamiento disponible en la calle' },
      { icon: 'ri-walk-line', label: 'Acceso por Av. 504, entre calles 51 y 53' },
    ],
  },
];

export default function SucursalesPage() {
  return (
    <PageShell>
      {(onOpenModal) => (
        <>
          <PageHero
            title="Sucursales &"
            highlight="Ubicación"
            subtitle="Encuéntranos"
            bgImage="https://readdy.ai/api/search-image?query=Mexico%20City%20CDMX%20urban%20street%20neighborhood%20map%20aerial%20view%20city%20buildings%20professional%20modern%20clean%20bright%20daytime%20clear%20sky%20street%20view&width=1920&height=600&seq=sucursales-hero-001&orientation=landscape"
            breadcrumbs={[
              { label: 'Inicio', to: '/' },
              { label: 'Sucursales' },
            ]}
          />

          <section className="py-24 bg-white">
            <div className="max-w-7xl mx-auto px-6">
              <div className="text-center mb-16 scroll-animate">
                <span className="inline-block text-[#3A86FF] font-semibold text-sm tracking-widest uppercase mb-3">
                  Cómo visitarnos
                </span>
                <h2 className="text-4xl font-extrabold text-[#0A2540] mb-4">
                  Nuestra{' '}
                  <span className="bg-gradient-to-r from-[#3A86FF] to-[#0A2540] bg-clip-text text-transparent">
                    Clínica
                  </span>
                </h2>
                <p className="text-gray-500 max-w-xl mx-auto font-light">
                  Estamos ubicados en San Juan de Aragón, Gustavo A. Madero, Ciudad de México. Fácil acceso en transporte público.
                </p>
              </div>

              {branches.map((branch) => (
                <div key={branch.id} className="scroll-animate">
                  {/* Map */}
                  <div className="rounded-3xl overflow-hidden border border-gray-100 mb-10" style={{ height: '420px' }}>
                    <iframe
                      title={branch.name}
                      src={branch.mapSrc}
                      className="w-full h-full border-0"
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                  </div>

                  {/* Info grid */}
                  <div className="grid lg:grid-cols-3 gap-6">
                    {/* Address */}
                    <div className="bg-[#f7f9fc] rounded-3xl p-7 border border-gray-100">
                      <div className="flex items-center gap-3 mb-5">
                        <div className="w-12 h-12 flex items-center justify-center bg-[#3A86FF]/15 rounded-2xl">
                          <i className="ri-map-pin-2-line text-[#3A86FF] text-xl" />
                        </div>
                        <div>
                          <span className="text-[#3A86FF] text-xs font-semibold uppercase tracking-widest">Dirección</span>
                          <h3 className="font-bold text-[#0A2540]">{branch.name}</h3>
                        </div>
                      </div>
                      <span className="inline-block bg-[#3A86FF] text-white text-xs px-3 py-1 rounded-full mb-4">
                        {branch.badge}
                      </span>
                      <p className="text-gray-600 text-sm mb-1">{branch.address}</p>
                      <p className="text-gray-600 text-sm mb-1">{branch.colony}</p>
                      <p className="text-gray-400 text-xs mb-5">{branch.zip}</p>
                      <a
                        href={branch.mapLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 bg-[#0A2540] hover:bg-[#0d3060] text-white px-5 py-2.5 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer w-fit"
                      >
                        <div className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-navigation-line" />
                        </div>
                        Cómo llegar
                      </a>
                    </div>

                    {/* Hours */}
                    <div className="bg-[#f7f9fc] rounded-3xl p-7 border border-gray-100">
                      <div className="flex items-center gap-3 mb-5">
                        <div className="w-12 h-12 flex items-center justify-center bg-emerald-500/15 rounded-2xl">
                          <i className="ri-time-line text-emerald-500 text-xl" />
                        </div>
                        <div>
                          <span className="text-emerald-500 text-xs font-semibold uppercase tracking-widest">Horario</span>
                          <h3 className="font-bold text-[#0A2540]">Horario de Atención</h3>
                        </div>
                      </div>
                      <div className="space-y-4">
                        {branch.hours.map((h) => (
                          <div key={h.day} className="flex items-center justify-between">
                            <span className="text-gray-600 text-sm">{h.day}</span>
                            <span className={`text-sm font-medium ${h.time === 'Cerrado' ? 'text-rose-400' : 'text-[#0A2540]'}`}>
                              {h.time}
                            </span>
                          </div>
                        ))}
                      </div>
                      <div className="mt-5 pt-5 border-t border-gray-200">
                        <div className="flex items-center gap-2">
                          <div className="w-2 h-2 rounded-full bg-emerald-400 flex-shrink-0" />
                          <span className="text-emerald-600 text-sm font-medium">Abierto ahora</span>
                        </div>
                      </div>
                    </div>

                    {/* Contact + Transport */}
                    <div className="bg-[#f7f9fc] rounded-3xl p-7 border border-gray-100">
                      <div className="flex items-center gap-3 mb-5">
                        <div className="w-12 h-12 flex items-center justify-center bg-amber-500/15 rounded-2xl">
                          <i className="ri-phone-line text-amber-500 text-xl" />
                        </div>
                        <div>
                          <span className="text-amber-500 text-xs font-semibold uppercase tracking-widest">Contacto</span>
                          <h3 className="font-bold text-[#0A2540]">Teléfono & WhatsApp</h3>
                        </div>
                      </div>
                      <a
                        href={`tel:${branch.phone.replace(/\s/g, '')}`}
                        className="flex items-center gap-2 text-[#0A2540] font-semibold text-lg hover:text-[#3A86FF] transition-colors cursor-pointer mb-3 whitespace-nowrap"
                      >
                        <div className="w-5 h-5 flex items-center justify-center text-[#3A86FF]">
                          <i className="ri-phone-fill" />
                        </div>
                        {branch.phone}
                      </a>
                      <a
                        href={branch.whatsapp}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 text-[#25D366] font-medium text-sm hover:opacity-80 cursor-pointer whitespace-nowrap mb-6"
                      >
                        <div className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-whatsapp-line" />
                        </div>
                        Escribir por WhatsApp
                      </a>

                      <p className="text-[#0A2540] font-semibold text-sm mb-3">Cómo llegar</p>
                      <div className="space-y-3">
                        {branch.transport.map((t) => (
                          <div key={t.label} className="flex items-start gap-3">
                            <div className="w-7 h-7 flex items-center justify-center bg-white rounded-lg border border-gray-200 flex-shrink-0">
                              <i className={`${t.icon} text-[#3A86FF] text-sm`} />
                            </div>
                            <span className="text-gray-500 text-xs leading-relaxed">{t.label}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* CTA */}
          <section className="py-20 bg-[#0A2540] relative overflow-hidden">
            <div className="absolute top-0 right-0 w-80 h-80 bg-[#3A86FF]/10 rounded-full blur-[100px]" />
            <div className="relative z-10 max-w-4xl mx-auto px-6 text-center scroll-animate">
              <h2 className="text-3xl font-extrabold text-white mb-4">
                ¿Listo para visitarnos?
              </h2>
              <p className="text-white/60 mb-8">Agenda tu cita y te esperamos en nuestra clínica.</p>
              <button
                onClick={onOpenModal}
                className="inline-flex items-center gap-2 bg-[#3A86FF] hover:bg-[#1a6aff] text-white px-8 py-4 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer hover:-translate-y-0.5"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-calendar-check-line" />
                </div>
                Agendar mi Cita
              </button>
            </div>
          </section>
        </>
      )}
    </PageShell>
  );
}
